// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-leader-js": () => import("/opt/build/repo/src/templates/leader.js" /* webpackChunkName: "component---src-templates-leader-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-kilo-js": () => import("/opt/build/repo/src/pages/kilo.js" /* webpackChunkName: "component---src-pages-kilo-js" */),
  "component---src-pages-page-2-js": () => import("/opt/build/repo/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

